export default __webpack_public_path__ + "static/media/ground_pattern.8d94e590.svg";